<template>
  <div class="landing">

    <!-- HERO -->
    <div class="hero">
      <img src="https://images.unsplash.com/photo-1604908176997-125f25cc6f3d">
      <h1>Xôi A Diểng</h1>
      <p>Xôi nóng - topping đầy đặn 🔥</p>
    </div>

    <!-- MENU -->
    <section>
      <h2>Món nổi bật</h2>

      <div class="menu">
        <div
            v-for="item in foods"
            :key="item.name"
            class="card"
            @click="openModal(item)"
        >
          <img :src="item.img">
          <div class="info">
            <h3>{{ item.name }}</h3>
            <p>{{ item.desc }}</p>
            <span>{{ item.price }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- MAP -->
    <section>
      <h2>Bản đồ</h2>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3728.3118810370993!2d106.68317751142993!3d20.859475793489985!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x314a7b0025379137%3A0xc0a6320c4d088a7!2zWMO0aSB0aOG7i3QgQSBEaeG7g25n!5e0!3m2!1svi!2s!4v1773746311306!5m2!1svi!2s" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </section>

    <!-- CONTACT -->
    <section>
      <h2>Liên hệ</h2>
      <p>📍 Hải Phòng</p>
      <p>📞 0123 456 789</p>
    </section>

    <!-- MODAL -->
    <div v-if="showModal" class="modal" @click.self="showModal=false">
      <div class="modal-box">
        <img :src="selected?.img">
        <h3>{{ selected?.name }}</h3>
        <p>{{ selected?.price }}</p>
      </div>
    </div>

    <!-- BOTTOM CTA -->
    <div class="bottom">
      <button @click="call">📞 Gọi</button>
      <button @click="zalo">💬 Zalo</button>
    </div>

  </div>
</template>

<script setup>
import { ref } from 'vue'

const showModal = ref(false)
const selected = ref(null)

const foods = ref([
  {
    name: 'Xôi Sườn Cay',
    price: '40K',
    desc: 'Đậm vị cay nhẹ',
    img: 'https://images.unsplash.com/photo-1550547660-d9450f859349'
  },
  {
    name: 'Xôi Full',
    price: '65K',
    desc: 'Full topping',
    img: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c'
  }
])

function openModal(item){
  selected.value = item
  showModal.value = true
}

function call(){
  window.location.href = "tel:0123456789"
}

function zalo(){
  window.open("https://zalo.me/0123456789")
}
</script>

<style scoped>
.landing {
  background: #f7f7f7;
  padding-bottom: 70px;
}

/* HERO */
.hero {
  padding: 16px;
}
.hero img {
  width: 100%;
  border-radius: 16px;
  height: 160px;
  object-fit: cover;
}
.hero h1 {
  margin-top: 10px;
}

/* MENU */
.menu {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}

.card {
  display: flex;
  background: white;
  border-radius: 16px;
  overflow: hidden;
}

.card img {
  width: 90px;
  height: 90px;
  object-fit: cover;
}

.info {
  padding: 10px;
}

.info span {
  color: #e74c3c;
  font-weight: bold;
}

/* MAP */
iframe {
  width: 100%;
  height: 200px;
  border-radius: 16px;
}

/* MODAL */
.modal {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-box {
  background: white;
  padding: 15px;
  border-radius: 16px;
  width: 90%;
}

/* BOTTOM */
.bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  gap: 10px;
  padding: 10px;
  background: white;
}
button {
  flex: 1;
  padding: 12px;
  border: none;
  background: #e74c3c;
  color: white;
  border-radius: 12px;
}
</style>